/**
 * Shared base for WebGPU-only post-processing effects (no WebGL path).
 */

import * as THREE from 'three';

import { type BaseEffectConfig, type EffectContext, IPostProcessEffect, type WebGLEffectData } from '../IPostProcessEffect.js';

export function hasConfigChanged<T extends BaseEffectConfig>(oldConfig: T, newConfig: T): boolean {
  const keys = new Set([...Object.keys(oldConfig), ...Object.keys(newConfig)]);
  for (const key of keys) {
    if ((oldConfig as Record<string, unknown>)[key] !== (newConfig as Record<string, unknown>)[key]) {
      return true;
    }
  }
  return false;
}

export function findMainLight(scene: THREE.Scene): THREE.Light | null {
  let mainLight: THREE.Light | null = null;
  scene.traverse(object3D => {
    if (mainLight || !(object3D instanceof THREE.Light)) return;
    mainLight = object3D;
  });
  return mainLight;
}

export abstract class WebGPUOnlyEffect<TConfig extends BaseEffectConfig> extends IPostProcessEffect<TConfig> {
  override createWebGLEffect(_config: TConfig, _context: EffectContext): WebGLEffectData {
    return { effects: [] };
  }

  override requiresRebuild(oldConfig: TConfig, newConfig: TConfig): boolean {
    return hasConfigChanged(oldConfig, newConfig);
  }
}
